import React from "react"
import { Grid } from "@mui/material"

import ListViewItem from "components/Algolia/Results/Product/ListViewItem"
import LockingSystemListViewItem from "./LockingSystem/LockingSystemListViewItem"

import { AlgoliaProductHit, AlgoliaLockingSystemHit } from "@secureo/common/typings/Algolia"
import { AlgoliaUIPageType } from "../AlgoliaSearchUI"

const ListView = ({ hits, locale, categoryName, pageType }: Props) => {
	if (hits.length === 0) return null

	const isLockingSystem = pageType === "locking-systems"

	return (
		<Grid container spacing={2}>
			{hits.map((hit, position) => {
				return (
					<Grid item xs={12} key={hit.objectID}>
						{isLockingSystem ? (
							<LockingSystemListViewItem
								hit={hit as AlgoliaLockingSystemHit}
								locale={locale}
								position={position + 1}
								categoryName={categoryName}
							/>
						) : (
							<ListViewItem
								hit={hit as AlgoliaProductHit}
								locale={locale}
								position={position + 1}
								categoryName={categoryName}
							/>
						)}
					</Grid>
				)
			})}
		</Grid>
	)
}

interface Props {
	hits: (AlgoliaProductHit | AlgoliaLockingSystemHit)[]
	locale: string
	categoryName: string
	pageType?: AlgoliaUIPageType
}

export default ListView
